import React, { useEffect, useState, useContext } from "react";
import { useUnidades } from "../../hooks/test/useUnidades";
import { Select } from "../../components/Select";
import Swal from "sweetalert2";
import useCeo from "../../hooks/useCEO";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import enhub from "./../../assets/img/icons/en-hub.jpeg";
import encedis from "./../../assets/img/icons/en-cedis.jpeg";
import { AuthContext } from "../../context/authContext/authContext";

export const TableroCedis = () => {
  useCeo({
    title: "Módulo de Administración de cedis",
    description: "Página de cedis",
  });
  const { getCedi, getCedisNegociosAll, postCedi, putCedi, getNegocios, postContingencia } =
    useUnidades();
  const { user } = useContext(AuthContext);
  const [cedis, setCedis] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [negocios, setNegocios] = useState([]);
  const [busqueda, setBusqueda]= useState("");
  const [form, setForm] = useState({
    id: "",
    nombre_cedis: "",
    direccion: "",
    negocio_id: "",
    cat_tipos_almacen_id: 1,
    idCedis: "",
    idFlujo: "",
    validageo: "",
    programarfin: "",
    actContingencia: "",
  });
  const reset = () => {
    setForm({
      id: "",
      nombre_cedis: "",
      direccion: "",
      negocio_id: "",
      cat_tipos_almacen_id: 1,
      idCedis: "",
      idFlujo: "",
      validageo: "",
      programarfin: "",
      actContingencia: "",
    });
  };
  useEffect(() => {
    getData();
    getCedisByNegocioId(user.negocio_id);
  }, []);
  const getData = async () => {
    let resp = await getNegocios();
    if (resp.ok) setNegocios(resp.negocios);
  };
  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };
  const getCedisByNegocioId = async (id) => {
    let resp = await getCedisNegociosAll(id);
    if (resp.ok) setCedis([...resp.cedis]);
  };

  const options = [
    {value: '0', text: '--Selecciona flujo--'},
    {value: '1', text: 'Manual'},
    {value: '2', text: 'Automático'},
  ];

  const save = async (event) => {
    event.preventDefault();
    const flag = validaciones();
    if (!flag) {
      return "";
    }

    let resp = null;
    if (!form.id) {
      resp = await postCedi(form);
    } else {
      resp = await putCedi(form);
    }
    if (resp.ok) {
      Swal.fire({
        title: "Operación realizada correctamente",
        text: "Todo fue realizado con éxito",
        icon: "success",
      });
      reset();
      return getData();
    }
  };
  const validaciones = () => {
    if (!form.negocio_id)
      showToastError("Favor de insertar la direccion de la Cedis");

    if (!form.nombre_cedis)
      showToastError("Favor de insertar el nombre de la Cedis");

    if (!form.direccion)
      showToastError("Favor de insertar la direccion de la Cedis");

    if (!form.nombre_cedis || !form.direccion || !form.negocio_id) return false;

    return true;
  };

  const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleChangeCedisHub=e=>{
    setBusqueda(e.target.value);
  }

  let results = !busqueda ? cedis 
    : cedis.filter((elemento)=> 
      elemento.nombre_cedis.toString().toLowerCase().includes(busqueda.toLowerCase())
    );

  const actualizarFlujo = async (idCedis) => {

    let resp = await getCedi(idCedis);

    if (resp.ok) {
      setForm({
        id: resp.cedis_id,
        nombre_cedis: resp.nombre_cedis,
        direccion: resp.direccion != null ? resp.direccion : "",
        negocio_id: resp.negocio_id,
        cat_tipos_almacen_id: resp.cat_tipos_almacen_id,
        idFlujo: resp.flujo_id,
        validageo: resp.valida_geo,
        programarfin: resp.programar_fin,
        actContingencia: resp.actContingencia,
      });
    }

    handleShow();

  }

  const newCedisHub = () => {
    
    Swal
    .fire({
        title: "CEDIS/HUB",
        html:
        '<select id="tipoAlmacen" class="form-select selectRegistro">'+
          '<option value="0" selected>Selecciona un tipo</option>'+
          '<option value="1">Cedis</option>'+
          '<option value="3">Hub</option>'+
        '</select>'+  
        (
          user.negocio_id === 1 || user.negocio_id === "1" || user.negocio_id === 2 || user.negocio_id === "2" ?
          (
            '<select id="negocio" class="form-select selectRegistro">'+
            '<option value="0" selected>Selecciona un negocio</option>'+
            
            negocios.map(res => {
                return (
                  '<option value='+res.negocio_id+'>'+res.negocio_nombre+'</option>'
                )
              })+
            
            '</select>'
          ) : " " 

        ) +
        '<select id="selectFlujo" class="form-select selectRegistro">'+
          '<option value="0" selected>Selecciona flujo</option>'+
          '<option value="1">Manual</option>'+
          '<option value="2">Automático</option>'+
        '</select>'+
        '<div class="row">'+
          '<label id="cedisHub" for="inputName" class="col-sm-3 col-form-label">Nombre</label>'+
          '<div class="col-sm-9">'+
            '<input id="nombre_cedis" name="nombre_cedis" type="text" class="form-control">'+
          '</div>'+
        '</div>'+
        '<div class="row">'+
          '<label id="direccionCedisHub" for="inputDireccion" class="col-sm-3 col-form-label">Dirección</label>'+
          '<div class="col-sm-9">'+
            '<input id="direccion" type="text" name="direccion" class="form-control">'+
          '</div>'+
        '</div>',
        showCancelButton: true,
        confirmButtonText: "Agregar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {

          let negocio = ""
          user.negocio_id === 1 || user.negocio_id === "1" || user.negocio_id === 2 || user.negocio_id === "2" ?
          (
            negocio = document.getElementById('negocio').value
          ):  negocio = user.negocio_id

          let tipoalmacen = document.getElementById('tipoAlmacen').value
          let flujo = document.getElementById('selectFlujo').value
          let nameCedis = document.getElementById('nombre_cedis').value
          let direccion = document.getElementById('direccion').value
          
          if (!nameCedis) {
            Swal.showValidationMessage(`El campo nombre es requerido`)
          }
          if (flujo === "0") {
            Swal.showValidationMessage(`El campo flujo es requerido`)
          }
          if (negocio === "0") {
            Swal.showValidationMessage(`El campo negocio es requerido`)
          }
          if (tipoalmacen === "0") {
            Swal.showValidationMessage(`El campo tipo es requerido`)
          }
        
          return { 
            catTiposAlmacenId: tipoalmacen, 
            idNegocio: negocio, 
            flujo: flujo,
            nameCedis: nameCedis, 
            direccion: direccion
          }
        }
    })
    .then(async result => {

      if (result.isConfirmed) {
        Swal.fire({
          icon: 'info',
          title: "¡Agregar!",
          confirmButtonText: "Si",
          showCancelButton: true,
          cancelButtonText: "No",
          preConfirm: () => {
            return { 
              catTiposAlmacenId: result.value.catTiposAlmacenId, 
              idNegocio: result.value.idNegocio, 
              flujo: result.value.flujo,
              nameCedis: result.value.nameCedis, 
              direccion: result.value.direccion
            }
          }
        }).then(async result => {
          if(result.isConfirmed){

            let formInsert = {
              nombre_cedis: result.value.nameCedis,
              direccion: result.value.direccion,
              negocio_id: result.value.idNegocio,
              cat_tipos_almacen_id: result.value.catTiposAlmacenId,
              flujo_id: result.value.flujo,
              valida_geo: 1,
              programar_fin: 0,
            };

            // Ejecuta método para insertar muevo cedis-hub
            let resp = await postCedi(formInsert);
            // Si se inserta bien el registro manda mensaje al usuario (Agregado)
            if(resp.ok){
              getCedisByNegocioId(result.value.idNegocio);
              Swal.fire({
                icon: 'success',
                title: 'Agregado',
                showConfirmButton: false,
                timer: 1500
              })
            }else{
              // Si no debe notificar el error de registro 
              Swal.fire({
                icon: 'error',
                title: 'Error al insertar favor de intentarlo nuevamente',
                showConfirmButton: false,
                timer: 1500
              });
            }
            
          }
        })
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }

  const actualizarCedisHub = () => {
    if (form.idFlujo === "0") {
      showToastError('Por favor seleccione un flujo');
    }else {
      Swal.fire({
        icon: 'warning',
        title: "¡Estas seguro que deseas modificar el flujo de viaje!",
        confirmButtonText: "Si",
        showCancelButton: true,
        cancelButtonText: "No",
      }).then(async result => {
    
        if(result.isConfirmed){

          let formUpdate = {
            id: form.id,
            nombre_cedis: form.nombre_cedis,
            direccion: form.direccion,
            negocio_id: form.negocio_id,
            cat_tipos_almacen_id: form.cat_tipos_almacen_id,
            flujo_id:form.idFlujo,
            valida_geo:form.validageo,
            programar_fin: form.programarfin,
          };

          let formContingencia = {
            activa: form.actContingencia ? 1 : 0,
            cedis_id: form.id
          }

          // Actualiza datos del Cedis/Hub (ejecuta metodo: putCedi )
          let resp = await putCedi(formUpdate);
          handleClose();
          let act = await postContingencia(formContingencia);

          console.log(act);
          
          // si el metodo regresa OK manda mensaje al usuario
          if(resp.ok){
            getCedisByNegocioId(form.negocio_id);
            Swal.fire({
              icon: 'success',
              title: 'Flujo modificado',
              showConfirmButton: false,
              timer: 1500
            });
          }else{
            Swal.fire({
              icon: 'error',
              title: resp.msg,
              showConfirmButton: true,
              confirmButtonText: "OK",
            });
          }
        }
      })
    }  
    
  }

  return (
    <div className="container">
      <div className="col-12 mx-auto">
        <div className="row justify-content-center">
          {
            user.negocio_id && (user.negocio_id === 1 || user.negocio_id === "1" || user.negocio_id === 2 || user.negocio_id === "2") ? 
            (
              <>
              <div className="col-4">
                <Select
                  name="negocio_id"
                  value={form.negocio_id}
                  onChange={(event) => {
                    handleChange(event);
                    getCedisByNegocioId(event.target.value);
                  }}
                  placeholder="Selecciona un negocio"
                  options={negocios.map((x) => {
                    return { value: x.negocio_id, text: x.negocio_nombre };
                  })}
                  className="form-control mb-3"
                ></Select>
              </div>
              </>
            ) : ""
          }
          
          <div className="col-4">
            <input 
              className="form-control me-2" 
              type="search" 
              placeholder="Buscar" 
              aria-label="Buscar"
              value={busqueda}
              onChange={handleChangeCedisHub}
            />
          </div>
          <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2">
            <button 
              id="newCedisHub" 
              type="button" 
              className="btn btn-primary"
              onClick={newCedisHub}
            >
              Agregar nuevo
            </button>
          </div>
          <div className="col-12">
            <div className="row">
              {results.map((x) => {
                return (
                  <>
                    
                    <div className="col-3 col-md-4 col-lg-3 car-cedis-hub" >
                      <a 
                        key={x.cedis_id} 
                        onClick={ () => actualizarFlujo(x.cedis_id) 
                        }
                      > 
                        <div className="card car-cedis-hub-itr car-efect-hover">
                          <div className="card-body" style={{ "overflow-y": "unset"}}>
                            <div className="row">
                              <div className="col-2">
                                {
                                  x.cat_tipos_almacen_id === 1 ? 
                                    <img src={encedis} alt="icon encedis"></img>
                                  : ""
                                }
                                {
                                  x.cat_tipos_almacen_id === 3 ? 
                                    <img src={enhub} alt="icon enhub"></img>
                                  : ""
                                }
                                
                                {/* <img src={enhub}></img> */}
                              </div>
                              <div className="col-10">
                                <h5 className="card-title">{x.nombre_cedis}</h5>
                              </div>
                              <div className="col-12">
                                <p className="type-flujo">FLUJO: {x.flujo_id === 1 ? "Manual": x.flujo_id === 2 ? "Automatico": ""}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <p id="tituloModal" className="text-center">
            CEDIS/HUB
          </p>
        </Modal.Header>
        <Modal.Body>
          <div className="row actflujo">
            <label id="cedisHub" className="col-sm-3 col-form-label">Nombre</label>
            <div className="col-sm-9">
              <input 
                id="nombre_cedis" 
                name="nombre_cedis" 
                type="text" 
                className="form-control" 
                value={form.nombre_cedis} disabled 
              />
            </div>
          </div>
          <div className="row">
            <label id="direccionCedisHub" className="col-sm-3 col-form-label">Dirección</label>
            <div className="col-sm-9">
              <input 
                id="direccion" 
                name="direccion"
                type="text" 
                className="form-control" 
                value={form.direccion}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row">
            <label id="inputflujo" className="col-sm-3 col-form-label">Flujo</label>
            <div className="col-sm-9">
              <select 
                id="selectFlujo" 
                name="idFlujo" 
                className="form-select selectRegistro" 
                defaultValue={form.idFlujo} onChange={handleChange}
              >
                {options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </select>
            </div>
            <label className="text-start">
              <input 
                type="checkbox" 
                id="valGeocercas" 
                name="validageo"
                onChange={(event) => {
                  setForm({ ...form, validageo: event.target.checked })
                }}
                checked={form.validageo ? true : false} 
              /> Validar Geocercas
            </label>
            <label className="text-start">
              <input 
                type="checkbox" 
                id="finalizarViajesAutomaticos" 
                name="programarfin"
                onChange={(event) => {
                  setForm({ ...form, programarfin: event.target.checked })
                }}
                checked={form.programarfin ? true : false} 
              /> Finalizar viajes después de las 11pm
            </label>
            <label className="text-start">
              <input 
                type="checkbox" 
                id="actContingencia" 
                name="actContingencia" 
                onChange={(event) => {
                  setForm({ ...form, actContingencia: event.target.checked })
                }}
                checked={form.actContingencia ? true : false} 
              /> Contingencia apertura por códigos
            </label>
          </div>
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={ () => actualizarCedisHub() }>
          Actualizar
          </Button>
          <Button variant="secondary" onClick={() => (handleClose())}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
